import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { AuthProvider } from '@/lib/auth/AuthProvider'

import { RouteErrorBoundary } from './RouteErrorBoundary'

interface AppProvidersProps {
  readonly queryClient: QueryClient
  readonly children: ReactNode
}

export function AppProviders({ queryClient, children }: AppProvidersProps) {
  // Sıra bilinçli: hata sınırı en dışta durur ki sağlayıcıların kendisi patlarsa da
  // yakalayabilsin; kimlik, veri katmanının içinde kalır çünkü sorgular oturuma bağlıdır.
  return (
    <RouteErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>{children}</AuthProvider>
      </QueryClientProvider>
    </RouteErrorBoundary>
  )
}
